import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form, Table, Alert } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import ResalesRequestService from '../../../services/resales-request';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';
import BootstrapTable from 'react-bootstrap-table-next';
import { ProfileType } from 'helpers/Enum';
import { RecordVoiceOverOutlined, ErrorOutlineOutlined, WhatsApp } from '@material-ui/icons';
import Unauthorized from 'components/Unauthorized';
import Select from 'react-select';
import Loading from 'components/Loading';
import { useCompany } from 'models';

export default function(){
  //const user = JSON.parse(localStorage.getItem('user'));
  const {company:currentCompany} = useCompany();

  const defaultFilters = { __search: '', per_page: 10, page: 1 };
  const [filters, setFilters] = useState(defaultFilters);
  const [reports, setReports] = useState({ data: [] });
  const [company, setCompany] = useState([]);
  const [info, setInfo] = useState({ segment: [], client_type: [] });
  const [erroRequired, setErroRequired] = useState({ campos: [], erro: false })

  const [formEdit, setFormEdit] = useState(false);
  const [formChanges, setFormChanges] = useState(null);
  const [wasModified, setWasModified] = useState(false);
  const [messageErro, setMessageErro] = useState(false);
  const Data = [];
  const [isLoading, setIsLoading] = useState(false);

  const [manufacturers, setManufacturers] = useState([])
  const [selectedManufacturer, setSelectedManufacturer] = useState(null)
  const [usersManufacturer, setUsersManufacturer] = useState([])
  const [showAlert, setShowAlert] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    let filters_aux = {
      ...filters,
      '__area_id': 1,
      '__profile_type_id': ProfileType.Attendance,
    };
    if (currentCompany)
      filters_aux["__company_id"] = currentCompany.headquarter_id == currentCompany.id ? currentCompany.id : currentCompany.headquarter_id;

    let users = ResalesRequestService.getResaleAttendance({ params: { ...filters_aux } });
    users
      .then(data => {
        setReports({ ...data.data, ...data.data.pagination });
      })
      .finally(() => setIsLoading(false));

  }, [filters]);

  useEffect(() => {
    if(!selectedManufacturer) return;
    fetchUsersProductProfileManufacturer(selectedManufacturer)
  }, [selectedManufacturer])

  useEffect(() => {
    fetchManufacturers()
    
  },[])

  const startTimer = (sec) => {
    setTimeout(() => {
      setShowAlert(false)
    }, sec*1000)
  }

  const fetchUsersProductProfileManufacturer = async ({ value }) => {
    let manufacturer_id = value
    const response = await ResalesRequestService.getUsersProductProfileManufacturer(manufacturer_id)
    const { data } = response.data

    setUsersManufacturer(data.map(({ manufacturer_id, user_name, alias, email, phone }) => ({ 
      manufacturer_id, 
      alias: alias ?? "--", 
      email, 
      phone: phone ?? "--", 
      name: user_name
    })))

    if (data.length == 0) {      
      setShowAlert(true)
      startTimer(3)
    }
  }  

  const fetchManufacturers = async () => {
    const response = await ResalesRequestService.getManufacturers()
    const { data } = response.data
    setManufacturers(data.map(({ id, name }) => ({ value: id, label: name })))
  }

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const handlePageChange = page => handleFilterChange({ page });

  const columns = [
    {
      dataField: 'name',
      text: 'Nome',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'alias',
      text: 'Cargo',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'type',
      text: 'Perfil',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'email',
      text: 'E-mail',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'phone',
      text: 'Telefone',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
  ];

  const renderData = () => {
    Object.values(reports.data).forEach((user) => {
      //user.forEach(profile => {
        Data.push({
          id: user.id,
          alias: user.alias ?? "--",
          name: user.name + ' ' + user.lastname,
          email: user.email,
          phone: user.phone? user.phone : '--',
          type: user.profile.name
        });
      //});
    });
  }

  const showMessageErro = () => {
    return (
      <Unauthorized />
    );
  }
  if (!currentCompany)
    return showMessageErro();
  renderData();
  const getTamanho = (tamanho) => {
    return window.innerWidth <= tamanho;
  }

  return (
    <>
      <Container>
        <Row className="mt-4">
          <RecordVoiceOverOutlined className="icon-title" />
          <h5 className="title-dashboard">Atendimento</h5>
        </Row>
        <Row className="d-flex flex-column">
          <Card.Body className="shadow bg-white rounded m-1 p-5">
            <Row className="mb-3">
              <Col md={12}>
                <span className="font-weight-bold h5"> Contato via WhatsApp:</span><br />
                <div className='mt-2 mb-5'>
                  <a href="https://api.whatsapp.com/send/?phone=551121696510&text&type=phone_number&app_absent=0" target='_blank'>
                    <WhatsApp /> <span className='h6'>+55 (11) 2169-6510</span>
                  </a>
                </div>
                <hr />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Registros por página:</Form.Label>
                  <Form.Control
                    as="select"
                    value={filters.per_page}
                    onChange={e =>
                      handleFilterChange({ per_page: e.target.value, page: 1 })
                    }
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col className="d-flex justify-content-end">
                <Form.Group>
                  <Form.Label>Pesquisa:</Form.Label>
                  <Form.Control
                    as="input"
                    onChange={e => handleFilterChange({ __search: '%' + e.target.value + '%', page: 1 })}
                  >
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col className="p-0">
                <BootstrapTable wrapperClasses={getTamanho(940) ? 'table-responsive' : ''} style={{ width: '100px' }}
                  id="table"
                  className="font-10"
                  keyField="id"
                  data={Data}
                  columns={columns}
                  striped
                  bordered
                  hover
                  condensed
                />
                <Row>
                  <Col>
                    {/* <Trans i18nKey="label:interpolateShowingRecords">
                      Showing {{ from: reports.from || '0' }} to{' '}
                      {{ to: reports.to || '0' }} from {{ total: reports.total }}{' '}
                      records
                    </Trans> */}
                  </Col>
                  <Col className="d-flex justify-content-end">
                    <Pagination
                      activePage={reports.current_page}
                      itemsCountPerPage={reports.per_page}
                      totalItemsCount={reports.total ? reports.total : 0}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                      prevPageText="‹"
                      nextPageText="›"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Row>
        <Row className="mt-4">
          <RecordVoiceOverOutlined className="icon-title" />
          <h5 className="title-dashboard">Fale com a nossa equipe de produto</h5>
        </Row>
        <Row className="d-flex flex-column mb-5">
          <Card.Body className="shadow bg-white rounded m-2 p-5">
            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Fabricante:</Form.Label>
                  <Select
                    isClearable
                    isSearchable
                    placeholder="Selecione um fabricante"
                    value={selectedManufacturer}
                    options={manufacturers}
                    onChange={e => {
                      if(!e) setUsersManufacturer([])
                      
                      setSelectedManufacturer(e)
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            {showAlert && usersManufacturer.length == 0 ? (
              <Alert variant='warning'>
                Nenhum usuário encontrado para esse fabricante!
              </Alert>
            ) : (<></>)}
            {usersManufacturer.length > 0 ? (
              <Row className="mt-4">
                <Col md={12}>
                  <Table
                    bordered
                    striped
                  >
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>Cargo</th>
                        <th>Email</th>
                        <th>Telefone</th>
                      </tr>
                    </thead>
                    <tbody>
                      {usersManufacturer.map((user, idx) => (
                        <tr key={idx}>
                          <td>{ user.name }</td>
                          <td>{ user.alias }</td>
                          <td>{ user.email }</td>
                          <td>{ user.phone }</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            ) : (<></>)}
          </Card.Body>
        </Row>
      </Container>
    </>
  );

};